import React from 'react';
import { Redirect } from 'react-router-dom';

export const useRedirectJourney = (journeyDetails, urlOnly = false) => {
    if (!journeyDetails || (journeyDetails && !journeyDetails?.referal)) return null;

    // console.log('useRedirectJourney:useRedirectJourney', journeyDetails);
    
    if(journeyDetails?.amc_completed === true || journeyDetails?.dsp_completed === true) {
        if (journeyDetails?.amc_completed === true) {
            if (urlOnly) return '/amazon-audience-report';
            return <Redirect to="/amazon-audience-report" />;
        } else if(journeyDetails?.dsp_completed === true) {
            if (urlOnly) return '/amazon-dsp/campaign';
            return <Redirect to="/amazon-dsp/campaign" />;
        }
    }

    if (journeyDetails?.referal === 'amc') {
        if (journeyDetails?.amc_completed === true) {
            if (urlOnly) return '/amazon-audience-report';
            return <Redirect to="/amazon-audience-report" />;
        } else if (journeyDetails?.dsp_requested === true) {
            if (urlOnly) return '/thankyou/dsp';
            return <Redirect to="/thankyou/dsp" />;
        } else if (journeyDetails?.dsp_ongoing === true) {
            if (urlOnly) return '/amazon-dsp-request/create';
            return <Redirect to="/amazon-dsp-request/create" />;
        } else if (journeyDetails?.amc_requested === true) {
            if (urlOnly) return '/thankyou/amc';
            return <Redirect to="/thankyou/amc" />;
        } else {
            if (urlOnly) return '/amazon-audience-instance/create';
            return <Redirect to="/amazon-audience-instance/create" />;
        }
    } else if (journeyDetails?.referal === 'dsp') {
        if (journeyDetails?.dsp_completed === true) {
            if (urlOnly) return '/amazon-dsp/campaign';
            return <Redirect to="/amazon-dsp/campaign" />;
        } else if (journeyDetails?.amc_requested === true) {
            if (urlOnly) return '/thankyou/amc';
            return <Redirect to="/thankyou/amc" />;
        } else if (journeyDetails?.amc_ongoing === true) {
            if (urlOnly) return '/amazon-audience-instance/create';
            return <Redirect to="/amazon-audience-instance/create" />;
        } else if (journeyDetails?.dsp_requested === true) {
            if (urlOnly) return '/thankyou/dsp';
            return <Redirect to="/thankyou/dsp" />;
        } else {
            if (urlOnly) return '/amazon-dsp-request/create';
            return <Redirect to="/amazon-dsp-request/create" />;
        }
    }

    return null;
};